import React from 'react';
import SellingAgentLayout from "./SellingAgentLayout";
import SellingAgentAuthorizerLayout from "./SellingAgentAuthorizerLayout";
import ADCULayout from "./ADCULayout";
import IssuerLayout from "./IssuerLayout";
import CaCheckerLayout from './CaCheckerLayout';
import CaMakerLayout from './CaMakerLayout';
import {
  SELLING_AGENT_AUTHORIZER_ROLE,
  SELLING_AGENT_ROLE,
  ADCU_ROLE,
  ISSUER_ROLE,
  INVESTOR_ROLE, BROKER_ROLE, ADMIN_SPU_ROLE, ADMIN_LISTING_OFFICER, UNDERWRITER_ROLE, CA_MAKER, CA_CHECKER
} from "../helpr/constants";
import InvestorLayout from "./InvestorLayout";
import BrokerLayout from "./BrokerLayout";
import AdminSPULayout from "./AdminSPULayout";
import AdminListingOfficerLayout from "./AdminListingOfficerLayout";

/*
  DefaultLayout - component for application main layout
*/
const DefaultLayout = ({user, role, modules}) => {
  return renderLayout(user, role, modules);
}

const renderLayout = (user, role, modules) => {
  switch(role) {
    case SELLING_AGENT_ROLE:
      return <SellingAgentLayout user={user} role={role} modules={modules} />
    case SELLING_AGENT_AUTHORIZER_ROLE:
      return <SellingAgentAuthorizerLayout user={user} role={role} modules={modules} />
    case ADCU_ROLE:
      return <ADCULayout user={user} role={role} modules={modules} />
    case ISSUER_ROLE:
      return <IssuerLayout user={user} role={role} modules={modules}/>
    case UNDERWRITER_ROLE:
      return <IssuerLayout user={user} role={role} modules={modules}/>
    case INVESTOR_ROLE:
      return <InvestorLayout user={user} role={role} modules={modules}/>
    case BROKER_ROLE:
      return <BrokerLayout user={user} role={role} modules={modules}/>
    case ADMIN_SPU_ROLE:
      return <AdminSPULayout user={user} role={role} modules={modules}/>
    case ADMIN_LISTING_OFFICER:
      return <AdminListingOfficerLayout user={user} role={role} modules={modules}/>
    case CA_CHECKER:
      return <CaCheckerLayout user={user} role={role} modules={modules}/>
    case CA_MAKER:
      return <CaMakerLayout user={user} role={role} modules={modules}/>
    default:
      console.log("Default Role")
      return <SellingAgentLayout user={user} role={role} modules={modules} />
  }
}

export default DefaultLayout;



